// getImplementationCostRange.js (No changes needed if it's already performant enough for its single call)
const getImplementationCostRange = (initiatives) => {
  if (!Array.isArray(initiatives)) {
    return {};
  }

  const groups = {
    '<not set>': [],
    'No value': [],
    'Negative value': [],
    'ETB 0-ETB 1Mn': [],
    'ETB 1Mn-ETB 10Mn': [],
    'ETB 10Mn-ETB 50Mn': [],
    'ETB 50Mn-ETB 100Mn': [],
    'ETB 100Mn-ETB 500Mn': [],
    'ETB 500Mn-ETB 1Bn': [],
    '>ETB 1Bn': [],
  };

  const getAnnualValue = (impact, stage) => {
    let annualValue = 0;
    if (impact.annuallyPlan && impact.annuallyPlan.length > 0) {
      annualValue = impact.annuallyPlan.reduce((sum, value) => sum + value, 0);
    }
    return annualValue;
  };

  initiatives.forEach((initiative) => {
    let totalRecurringBenefit = 0;
    let totalCost = 0;
    const initiativeImpacts = initiative.KPI || [];
    const impacts = initiative.impact || [];
    // Changed: Only push to 'No value' if both KPI and impacts are empty
    if (initiativeImpacts.length === 0 && impacts.length === 0) {
      groups['No value'].push(initiative);
      return;
    }


    initiativeImpacts.forEach((impact) => {
      if (
        impact.UniversalKPI === 'One Time Implementation Cost for Amortization' ||
        impact.UniversalKPI === 'One Time Implementation Cost for Depreciation'
      ) {
        totalRecurringBenefit += getAnnualValue(impact, initiative.stage);
      }
    });
    impacts.forEach((impact) => {
      if (impact.frequencyAndDirection === 'One implementation Cost (ETB)') {
        totalCost += getAnnualValue(impact, initiative.stage);
      }
    });
    let totalImplementationCost = totalRecurringBenefit + totalCost;

    // Categorize initiatives based on totalImplementationCost
    if (initiativeImpacts.length === 0) {
      groups['No value'].push(initiative);
    } else if (totalImplementationCost < 0) { // Costs should ideally not be negative in this context
      groups['Negative value'].push(initiative); // Keep this for robustness but might indicate data issues
    } else if (totalImplementationCost >= 0 && totalImplementationCost <= 1) {
      groups['ETB 0-ETB 1Mn'].push(initiative);
    } else if (totalImplementationCost <= 10 && totalImplementationCost > 1) {
      groups['ETB 1Mn-ETB 10Mn'].push(initiative);
    } else if (totalImplementationCost <= 50 && totalImplementationCost > 10) {
      groups['ETB 10Mn-ETB 50Mn'].push(initiative);
    } else if (totalImplementationCost <= 100 && totalImplementationCost>50) {
      groups['ETB 50Mn-ETB 100Mn'].push(initiative);
    } 
    else if (totalImplementationCost <= 500 && totalImplementationCost>100) {
      groups['ETB 100Mn-ETB 500Mn'].push(initiative);
    } 
    else if (totalImplementationCost <= 1000 && totalImplementationCost>500) {
      groups['ETB 500Mn-ETB 1Bn'].push(initiative);
    } 
    else {
      groups['>ETB 1Bn'].push(initiative);
    }
  });
  return groups;
};

export default getImplementationCostRange;